import { useState } from 'react';
import { createRoot } from 'react-dom/client';

import { BrowserRouter, Route, Routes, Link } from "react-router-dom"

import Box from '@mui/material/Box'

import Header from "./Header";

import IconRow from './Section1/IconRow';
import Project from './Section1/Project';
import Mitmachen from './Section1/Mitmachen';
import Proben from './Section1/Proben';
import Phytoplasma from './Section2/Phytoplasma';
import Wirtspflanzen from './Section2/Wirtspflanzen';
import Symptome from './Section2/Symptome';
import Pictures from './Section2/Pictures';
import Formular from './Section3/Formular';

import Footer1 from './Footer1';

function Part1() {

    return (

        <>

            <IconRow />

            <Project />

            <Mitmachen />

            <Proben />

            <Footer1 />
            
        </>

    );
}

export default Part1;
